import beaconScanListener from './beaconScanListener';
import { logger } from '../../../tools/logger';
import { mutationTypes } from '../../../types';

export default {
	state: {
		config: {
			areaThreshold: -60,
			areaHysterese: 10,
			isActive: false,
		},
		detectedAreaBeacons: {},
		nearbyArticles: [],
		areaCount: 0,
		timestamp: null,
		descriptionMap: {},
	},
	mutations: {
		[mutationTypes.areaBeaconAlgorithmUpdate](state, { areaBeacons, nearbyArticles }) {
			logger.log('Articles Nearby', nearbyArticles);

			if (state.nearbyArticles.sort().join(',') !== nearbyArticles.sort().join(',')) {
				state.timestamp = Date.now();
				state.nearbyArticles = nearbyArticles;
			}
			state.detectedAreaBeacons = areaBeacons;
			state.areaCount = Object.keys(areaBeacons).length;
		},
		[mutationTypes.areaBeaconSetConfig](state, config) {
			state.config = Object.assign(state.config, config);
		},
		[mutationTypes.areaBeaconSetDescriptionMap](state, { descriptionMap }) {
			state.descriptionMap = descriptionMap;
		},
	},

	actions: {},
	plugins: [beaconScanListener],
};
